import { useCallback } from 'react';
import { useUrlParams } from '../../../hooks/useUrlParams';

export enum LooksDesktopModuleMode {
  Large = 'large',
  Small = 'small'
}

export const useLooksDesktopModule = () => {
  const { params, addParams } = useUrlParams();

  const sanitizeMode = (mode?: string | string[]): LooksDesktopModuleMode =>
    mode === LooksDesktopModuleMode.Small || mode === LooksDesktopModuleMode.Large
      ? mode
      : LooksDesktopModuleMode.Small;

  const mode = sanitizeMode(params.mode);

  const changeMode = useCallback(
    (mode: LooksDesktopModuleMode) => {
      addParams({ mode });
    },
    [addParams]
  );

  return {
    mode,
    changeMode,
    selectedLook: params.look,
    isAnyLookSelected: params.look !== undefined
  };
};
